/*global diy, jimdoData*/

var $ = require('jquery');
var features = require('diy/util/features');
var siteadmin = require('./siteadmin');
var renderPrivacyNotice = require('diy/privacy/Notice').renderNotice;

module.exports = function(controller) {
    'use strict';

    /* the default window behavior will be used in case of un-specified behavior */
    var defaultWindowBehavior = {
        header : {
            small : false
        },
        resizable : {
            minWidth : 550,
            minHeight : 712
        },
        size : { /* they start with a predefined width height */
            width : 600,
            height : 700,
            /* and save their window size in a common place */
            persistentId : 'basic'
        },
        footer : {}
    /* by default, they have footer */
    };

    var speed = 400, /* animation speed in Site Admin Window */
    sidebarWidth = 86, /* the Site Admin bar width */
    windowMargin = 50, /* the margin of the site window untill the window edge*/
    windowFooterHeight = 50, /* the footer's height */
    windowHeaderHeight = 0, /* the header's height */
    windowHeaderHeights = {
        small : 34,
        normal : 87
    },

    /*
     * these are the default resizable options and also some resize-logic used
     * if the window has resizable behavior
     */
    resizableOptions = {
        minWidth : 350,
        maxWidth : null,
        minHeight : 400,
        maxHeight : null,
        containment : 'document',
        helper : 'cc-window-resizable-proxy',
        handles : {
            sw : '.sa-resizable'
        },
        start : function(e, ui) {
            /*
             * put an invisible overlay just bellow the resized window to
             * prevent interaction with iframes or other elements in the page
             */
            var windowZIndex = parseInt(ui.element.parent().css('z-index'), 10);
            if (windowZIndex) {
                $('<div id="cc-resizable-window-overlay">').css({
                    zIndex : windowZIndex + 1
                // changed from - to +, it was not working properly
                }).appendTo($(document.body));
            }
        },
        stop : function(e, ui) {
            /*
             * we resize the header's width first, as we may have a subheading
             * text that extends on two or more lines. at this point, the header
             * is not itself resized, so when computing it's height, the old one
             * will be used and an incorrect height will be used. So we force it
             * to resize, to gain the new height needed for the window size
             * calculations
             */
            $siteAdminWinHeader.width(ui.size.width);
            /* resize it to the new size */
            self.resize({
                width : ui.size.width,
                height : ui.size.height
            });
            $win.css($.extend(ui.originalPosition, {
                left : 'auto',
                top : 0
            }));

            /* trigger finishing the resizeComleted (for ex. for moduleSelector) */
            $(document).trigger('diy-siteadmin-window-resize-completed',
                    ui.size);

            /* remove the resize overlay */
            $('#cc-resizable-window-overlay').remove();
        }
    };

    var $win,
        $iframe,
        $contentWrapper,
        $contentContainer,
        $navi,
        $title,
        $descr,
        $saveBtn,
        $siteAdminWinHeader,
        $smallLoader,
        $resizeHandle,
        $footer,
        $closeBtn;

    var ini = function() {
        $win = $($('#sa-template').html()).insertAfter('#sa-template');
        $contentWrapper = $win.find('main');
        $contentContainer = $win.find('.sa-main-content');
        $navi = $win.find('nav .sa-navigation');
        $title = $win.find('header h1');
        $descr = $win.find('header h2');
        $saveBtn = $win.find('footer .sa-footer-save');
        $closeBtn = $win.find('footer .sa-footer-close');
        $siteAdminWinHeader = $win.find('header');
        $smallLoader = $('.sa-header-buttons .loading-placeholder');
        $resizeHandle = $win.find('.sa-resizable');
        $footer = $win.find('footer');
    };

    ini();

    var self = this,
        windowOpened = false,
        behavior = [], /* the current behaviors of the window */
        contentType = "iframe-local";

    var behaviors = {

        /* resizable behavior: makes the window resizable */
        resizable : {
            hide : function(opts) {
                $resizeHandle.hide();
                // HACK: hide behavior is called even if it's never been activated
                if ($win.is('.ui-resizable')) {
                    $win.resizable('disable');
                }
            },
            show : function(opts) {
                var effectiveOptions = $.extend({}, resizableOptions, opts);
                $resizeHandle.show();
                if (!$win.is('.ui-resizable')) {
                    $win.resizable(effectiveOptions);
                } else {
                    $win.resizable('enable');
                    $win.resizable('option', effectiveOptions);
                }
            }
        },

        /*
         * size behavior: sizes the window and makes it save it's size in a
         * persistent storage
         */
        size : {
            hide : function(opts) {
                $(window).off('.saWindowSizeBehavior');
            },
            show : function(opts) {
                var sizeobj;

                var controllerName = siteadmin.getController().getControllerName(),
                    controller = diy.editor.siteadmin.controllers[controllerName];
                if (controller && typeof controller['getWindowSize'] === 'function') {
                    $(window).on('resize.saWindowSizeBehavior', function() {
                        var responsiveSize = controller.getWindowSize();
                        self.resize(responsiveSize);
                    });
                    var responsiveSize = controller.getWindowSize();
                    self.resize(responsiveSize);
                    return;
                }

                /*
                 * try and get the persistent size cookie for this type of
                 * window
                 */
                try {
                    sizeobj = $.parseJSON($.cookie('diy-siteadmin-window-size-persistentId-' + opts.persistentId));
                } catch (e) {
                    sizeobj = null;
                }
                /*
                 * if cookie was previously set, use it. if not, just use the
                 * width and height
                 */
                if (sizeobj && sizeobj.width && sizeobj.height) {
                    self.resize(sizeobj);
                } else {
                    self.resize({
                        width : opts.width || resizableOptions.minWidth,
                        height : opts.height || resizableOptions.minHeight
                    });
                }
            }
        },
        closeButton : {
            hide : function(opts) {
                $contentWrapper.find('.closeButton').hide();
            },
            show : function(opts) {
                // create and show a button
                var $button = $contentWrapper.find('.closeButton');
                if (!$button.length) {
                    $button = $('<button class="closeButton">X</button>')
                            .appendTo($contentWrapper);
                    $button
                            .click(function() {
                                var controllerName = siteadmin
                                        .getController().getControllerName(),
                                controller = diy.editor.siteadmin.controllers[controllerName];
                                if (typeof controller['minimizeButtonClick'] === 'function') {
                                    controller.minimizeButtonClick(opts);
                                }

                            });
                }
                $button.show();
            }
        },
        header : {
            hide : function(opts) {
                if (opts.small) {
                    $siteAdminWinHeader.removeClass('cc-window-header-small');
                }
                windowHeaderHeight = 0;
                $siteAdminWinHeader.hide();
            },
            show : function(opts) {
                if (opts.small) {
                    $siteAdminWinHeader.addClass('cc-window-header-small');
                    windowHeaderHeight = windowHeaderHeights.small;
                } else {
                    windowHeaderHeight = windowHeaderHeights.normal;
                }
                $siteAdminWinHeader.show();
                $win.css('margin-top', null);
            }
        },

        /* footer behavior: adds a footer to the window */
        footer : {
            hide : function(opts) {
                $footer.hide();
            },
            show : function(opts) {
                $footer.show();
            }
        },

        overlay : {
            hide : function(opts) {
                $('#siteadmin-window-overlay').hide();
            },
            show : function(opts) {

                // grab a hold of the overlay container
                var $overlay = $('#siteadmin-window-overlay');

                // create overlay element if it hasn't yet
                if ($overlay.length === 0) {

                    // create the container
                    $overlay = $(
                        '<div id="siteadmin-window-overlay" class="diye ui-overlay">' +
                            '<div class="ui-widget-overlay"></div>' +
                        '</div>'
                    ).hide().appendTo('body');

                    // z-index needs to be on top of any web-app overlay
                    $overlay.find('.ui-widget-overlay').css('z-index', 50010);

                    // bind or unbind the alert on click, depending on options
                    if (typeof opts.alertOnClick !== 'undefined') {
                        $overlay
                            .bind(
                            'click.overlayAlertOnClick',
                            function() {
                                var controllerName = siteadmin
                                    .getController()
                                    .getControllerName();
                                var controller = diy.editor.siteadmin.controllers[controllerName];

                                if (typeof controller['showAlertOnClickAway'] === 'function') {
                                    controller.showAlertOnClickAway(opts);
                                }
                            });
                    }
                    else {
                        $overlay.unbind('click.overlayAlertOnClick');
                    }

                } // end of create container if not exist

                // set full transparency or semi-opaque, depending on options
                if (opts.transparent === true) {
                    $overlay.find('.ui-widget-overlay').addClass('transparent');
                }
                else {
                    $overlay.find('.ui-widget-overlay').removeClass('transparent');
                }

                // done, ready to show
                $overlay.show();
            }
        },

        /* loadingBox behavior: adds a loading screen to the window */
        loadingBox : {
            hide : function(opts) {
                self.loadingBox.destroy(opts);
            },
            show : function(opts) {
                self.loadingBox.init(opts);
            }
        },

        contentScrollable : {
            hide : function(opts) {
                $contentContainer.css('overflow', 'hidden');
            },
            show : function(opts) {
                $contentContainer.css('overflow', 'auto');
            }
        },

        minimizable : {
            hide: function(opts) {
                var miniMaxiButton = $win.find('.cc-sa-window-content-minimize_maximize');
                miniMaxiButton.hide();
                miniMaxiButton.removeClass('maximize');
                miniMaxiButton.addClass('minimize');
                miniMaxiButton.find('.does-minimize').show();
                miniMaxiButton.find('.does-maximize').hide();

            },
            show: function(opts) {
                var controllerName = siteadmin
                        .getController().getControllerName();
                var controller = diy.editor.siteadmin.controllers[controllerName];
                var tplMin, tplMax;

                if (typeof controller['minimizableButtonTemplate'] !== 'undefined') {
                    tplMin = controller.minimizableButtonTemplate('minimize');
                    tplMax = controller.minimizableButtonTemplate('maximize');
                } else {
                    tplMin = '<div>-</div>';
                    tplMax = '<div>+</div>';
                }

                var positionButton = function(button) {
                    setTimeout(
                            function() {
                                var width = button.outerWidth();
                                var height = button.outerHeight();
                                button.css('left', (width > height) ? -height
                                        : -width);
                                button.css('top', (width > height) ? width : 0);
                            }, 0);
                };

                var miniMaxiButton = $win.find('.cc-sa-window-content-minimize_maximize');
                if (!miniMaxiButton.length) {
                    // create the button
                    miniMaxiButton = $('<div class="cc-sa-window-content-minimize_maximize"></div>');
                    // it's a minimize by default
                    $(tplMin).addClass('does-minimize')
                            .appendTo(miniMaxiButton);
                    $(tplMax).addClass('does-maximize').hide().appendTo(
                            miniMaxiButton);
                    miniMaxiButton.addClass('minimize');
                    $contentWrapper.prepend(miniMaxiButton);

                    var oldBh = $.extend(true, {}, behavior);
                    var newBh = opts.dataWindowBehavior;
                    miniMaxiButton.bind('click', function() {

                        var $this = $(this);
                        var action;
                        if ($this.hasClass('minimize')) {
                            action = 'minimize';
                            newBh.minimizable = {};
                            self.setBehavior(newBh);
                            self.resize();

                            $this.removeClass('minimize');
                            $this.addClass('maximize');
                            $this.find('.does-minimize').hide();
                            $this.find('.does-maximize').show();
                        } else {
                            action = 'maximize';
                            self.setBehavior(oldBh);
                            self.resize();

                            $this.removeClass('maximize');
                            $this.addClass('minimize');
                            $this.find('.does-maximize').hide();
                            $this.find('.does-minimize').show();
                        }
                        positionButton($this);
                        $(document).trigger(
                                'diy-siteadmin-window-minimizable-state', [ {
                                    state : action
                                } ]);
                    });
                }

                miniMaxiButton.show();
                positionButton(miniMaxiButton);

            }
        }
    }; // end behaviors

    this.headerData = {};
    this.footerData = {};
    this.windowSize = {};
    this.originalWindowBehavior = {};

    /**
     * retrieves current window size
     *
     * @returns {*}
     */
    this.getWindowSize = function() {
      return this.windowSize;
    };

    this.getMinMaxState = function() {
        var button = $win.find('.cc-sa-window-content-minimize_maximize');
        if($(button[0]).hasClass('maximize')){
            return 'min';
        } else if ($(button[0]).hasClass('minimize')) {
            return 'max';
        }
    };

    this.isOpened = function() {
        return windowOpened;
    };

    this.init = function() {
        /* creating the content iframe */
        $iframe = $('<iframe frameborder="0" name="cc-sa-iframe" src="about:blank"></iframe>');
        $iframe.appendTo($contentWrapper);

        /* add privacy notice in footer */
        if (features('privacyNotice')) {
            var noticeWrapper = $('<div class="privacy-policy-notice-wrapper">');
            $contentWrapper.prepend(renderPrivacyNotice(noticeWrapper[0]));
        }

        /* react on window resize */
        $(window).bind('resize', function() {
            if (self.isOpened()) {
                self.resize(self.windowSize);
                self.checkSelectedPointerPosition();
            }
        });

        /*
         * hide site admin window to hide styleless html after classes were
         * removed
         */
        $(window).bind('unload', self.close);

        /* bind siteadmin window close and show events */
        $(document).bind('diy-siteadmin-window-close', $.proxy(self.close, this));
        $(document).bind('diy-siteadmin-window-show', $.proxy(self.show, this));

        $win.actionController(this, {
            history : true
        });

        $closeBtn.find('button').button().click($.proxy(self.closeWindowClick, this));
    };

    /**
     * Sets the window behavior to a new one Hides the previous one and shows
     * the new one
     *
     * @param {string|object} bh the new behavior
     */
    this.setBehavior = function(bh) {
        var b;
        /* in case no behavior, use the default one */
        if (!bh) {
            bh = defaultWindowBehavior;
        }

        /* the behavior may come as a string or as an object */
        if ('string' === typeof bh) {
            bh = $.parseJSON(bh);
        }
        bh = $.extend(true, {}, defaultWindowBehavior, bh);

        /* remove old behaviors from the window */
        for (b in behaviors) {
            if (behaviors.hasOwnProperty(b) && behaviors[b] !== false) {
                behaviors[b].hide(behaviors[b]);
            }
        }

        /* the new behavior */
        behavior = bh;

        /* add new behaviors to the window */
        for (b in behavior) {
            if (behavior.hasOwnProperty(b) && behavior[b] !== false) {
                behaviors[b].show(behavior[b]);
            }
        }
    };

    this.show = function() {
        /* the window is now opened */
        // TODO perhaps there is a better way to do this
        windowOpened = true;

        var openedControllerName = siteadmin
                .getController()
                .getControllerName(),
            openedController = diy.editor.siteadmin.controllers[openedControllerName];

        controller.bindEvent();

        /* stop any animations on the Site Admin and restore it visible */
        // TODO: check if show changes visibility as well so we can remove the css property
        if ($win.hasClass('ui-helper-hidden-accessible')) {
            $win.removeClass('ui-helper-hidden-accessible');
        }
		$win.stop(true).show().css('visibility', 'visible').css('opacity', null);
        /* add new behaviors to the window */
        var b;
        for (b in behavior) {
            if (behavior.hasOwnProperty(b) && behavior[b] !== false) {
                behaviors[b].show(behavior[b]);
            }
        }
        if (typeof openedController !== 'undefined' &&
            typeof openedController['show'] === 'function') {
            openedController.show();
        }
    };

    this.hide = function() {
        /* the window is now opened */
        // TODO perhaps there is a better way to do this
        windowOpened = false;
        var openedControllerName = siteadmin
            .getController(),
            openedController = '';

        controller.unbindEvent();

        if (openedControllerName !== null) {
            openedControllerName = openedControllerName.getControllerName();
            openedController = diy.editor.siteadmin.controllers[openedControllerName];
        }

        if (typeof openedController !== 'undefined' &&
            typeof openedController['hide'] === 'function') {
            openedController.hide();
        }
        /* add new behaviors to the window */
        var b;
        for (b in behavior) {
            if (behavior.hasOwnProperty(b) && behavior[b] !== false) {
                behaviors[b].hide(behavior[b]);
            }
        }
        /* stop any animations on the Site Admin and restore it visible */
        if (!$win.hasClass('ui-helper-hidden-accessible')) {
            $win.addClass('ui-helper-hidden-accessible');
        }
        $win.stop(true).css('opacity', null);
    };

    /**
     * Shows or hides the loading indicator
     *
     * @param {string}
     *            sw can take values like 'show' and 'hide'
     */
    this.loading = function(sw) {
        if (sw === 'show') {
            $contentWrapper.prepend('<div class="cc-window-loading"><div class="rotate-animation"></div></div>');
        } else {
            $contentWrapper.find('.cc-window-loading').remove();
        }
    };
    this.smallLoading = function (sw, bottomDistance, rightDistance) {
        if (sw === true) {
            if (!isNaN(parseInt(bottomDistance))) {
                $smallLoader.css({bottom: bottomDistance + 'px'});
            }
            if (!isNaN(parseInt(rightDistance))) {
                $smallLoader.css({right: rightDistance + 'px'});
            }
            $smallLoader.show();
        } else {
            $smallLoader.hide();
        }
    };

    /**
     * currently used for making custom CSS rules ex: override header, footer,
     * any other elemnets in the site admin ex:
     * [data-controller-name="myController"] { }
     */
    this.setAttribute = function(v) {

        var attrFn = function(val) {
            var oldControllerName = $win.attr('data-controller-name');
            if (oldControllerName) {
                $win.removeClass('cc-sa-controller-' + oldControllerName);
                $win.removeAttr('data-controller-name');
            }
            if (val) {
                $win.attr('data-controller-name', val);
                $win.addClass('cc-sa-controller-' + val);
            }
        };

        attrFn(v);
    };

    this.destroy = function() {
        var controllerName = controller.getControllerName(),
            currentController = diy.editor.siteadmin.controllers[controllerName];
        if (typeof currentController !== 'undefined' &&
            typeof currentController['reset'] === 'function') {
            currentController.reset();
        }

        $win.remove();
    };


    /**
     * Sets the window title
     *
     * @param {string}
     *            title the title to be set
     */
    this.updateID = function (id) {
        self.headerData.id = id;
    };

    this.getID = function() {
        return self.headerData.id;
    };

    /**
     * Sets the window title
     *
     * @param {string} title the title to be set
     */
    this.updateTitle = function(title) {
        $title.html(title);
        self.headerData.title = title;
    };

    /**
     * Sets the window description
     *
     * @param {string}
     *            descr the description to be set
     */
    this.updateDescr = function(descr) {
        $descr.html(descr);
        self.headerData.descr = descr;
    };

    this.setContentType = function(ct) {
        contentType = ct;
        if (ct === 'iframe-local' || ct === 'iframe-external') {
            $contentContainer.hide();
            $iframe.show();
        } else {
            $contentContainer.show();
            $iframe.hide();

            /*
             * ==============================================================
             * fixes bug 217862 (IE8 bug)
             * ============================================================== On
             * Internet Explorer 8 (of course), after clicking anywhere in
             * "Style" and switching to Module Selector, the scrollbars and
             * clicks don't work at all and all the interface looks frozen. This
             * was because of the click remained focused in the iframe
             * containing "Style" The only way to lose focus of that iframe was
             * to set it's source to about:blank, wait a bit, and then hide the
             * loading indicator (the top right of the panel) In this way the
             * iframe will lose focus and will allow normal events trigger on
             * the main window rather than inside the iframe. The following fix
             * is only executed on IE8
             */
            if ($.isBrowser.ie8) {
                controller.unloadSAC();
                $iframe.attr('src', 'about:blank');
            }
        }
    };

    /**
     * gets the content element depending on the content type
     *
     * @return {jQuery} the content element
     */
    this.getContentElement = function() {
        if ('iframe-local' === contentType || 'iframe-external' === contentType) {
            return $iframe;
        } else {
            //any other contentType, return the element
            //curently: inline, delegated
            return $contentContainer;
        }
    };

    /**
     * Click event on navigation tabs in the window
     */
    this.naviItemClick = function(e, specificController) {
        /* remove active class from all the navigation tabs */
        $('a', $navi).removeClass('cc-sa-active');

        /* sets behavior and content type */
        var windowBehavior = $(this).attr('data-window-behavior');
        self.setBehavior(windowBehavior);
        self.setContentType($(this).attr('data-content-type') || 'iframe-local');
        specificController = specificController || $(this).attr('data-identifier');
        /* make current tab active */
        $(this).addClass('cc-sa-active');

        /* set window behavior and content type */
        controller.load({
            element : this,
            controller : specificController,
            windowBehavior : windowBehavior,
            contentType : $(this).attr('data-content-type')
        });

        /* show the controller */
        controller.show();

        return false;
    };

    this.updateHelpTopic = function(topic) {
        var helpButton = $siteAdminWinHeader.find('.cc-sa-button-help'), isVideo = window.guidedAssistant &&
                window.guidedAssistant.isVideoHelpTopic(topic);

        helpButton.attr('data', topic);
        if (isVideo) {
            helpButton.addClass('cc-sa-button-help-video');
        } else {
            helpButton.removeClass('cc-sa-button-help-video');
        }
        if (topic) {
            helpButton.show();
        } else {
            helpButton.hide();
        }
    };

    this.updateFeatureGuidanceHelp = function(stepId) {
        var bubbleButton = $siteAdminWinHeader.find('.feature-guidance-help-button');
        if (stepId) {
            bubbleButton.attr('data', stepId).show();
        } else {
            bubbleButton.hide();
        }
    };

    /**
     * updates the site admin's window navigation (tabs) active state
     *
     * @param id {String|Number} if it's a string, it will use the "identifier" parameter
     *                           of the navigation link, if it's a number it will be that index
     */
    this.setNaviActiveItem = function(id) {
        if (!isNaN(parseInt(id))) {
            $navi.find('ul li').eq(id).find('a').trigger('click');
        } else {
            $navi.find('ul li a[data-identifier=' + id + ']').trigger('click');
        }
    };

    /**
     * This function updates the navigation zone (the tabs) with a given content
     *
     * @param {Array}
     *            navigation the content for the tabs
     */
    this.updateNavi = function(navigation) {
        /*
         * extra space to add to the navi for the new minimum width an window
         * can have
         */
        var extraSpace = 10, navi = '', i = 0, item, wb;
        if (behavior.header && behavior.header.small) {
            extraSpace = 110;
        }
        if (navigation && $.isArray(navigation)) {
            navi += '<div id="cc-sa-navi-tabs" class="ui-tabs ui-widget ui-widget-content ui-corner-all">';
            navi += '<ul class="ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all">';
            for (i = 0; i < navigation.length; i = i + 1) {
                item = navigation[i];
                navi += '<li class="ui-state-default ui-corner-top' +
                        (item.active ? ' ui-tabs-selected ui-state-active'
                                : '') + '">';
                if(item.url === undefined) {
                    navi += '<a href="#" ';
                } else {
                    navi += '<a href="' + item.url +
                        '" target="cc-sa-iframe" ';
                }

                navi += ' class="' + (item.active ? 'active' : '') + '" ';

                if (item.identifier) {
                    navi += ' data-identifier="' + item.identifier + '" ';
                }

                if (item.windowBehavior) {
                    wb = "";
                    try {
                        wb = $.toJSON(item.windowBehavior).replace(/&/g,
                                "&amp;").replace(/</g, "&lt;").replace(/>/g,
                                "&gt;").replace(/"/g, "&quot;").replace(/'/g,
                                "&#039;");
                    } catch (e) {
                    }
                    navi += ' data-window-behavior="' + wb + '"';
                }
                if (item.contentType) {
                    navi += ' data-content-type="' + item.contentType + '"';
                }
                navi += ' data-action="naviItem">' + item.title + '</a></li>';
            }
            navi += '</ul>';
            navi += '</div>';
        }

        /* set the navi content */
        $navi.html(navi);

        /* apply custom callbacks */
        $navi.find('#cc-sa-navi-tabs ul li a').each(
                function(index) {
                    $(this).click(
                            function(e) {
                                var res = navigation[index].callback;

                                /* save the timestamp for other tracking points */
                                $(document).trigger('diy-editor-saveUserClickTimestamp', {
                                    sectionCodeName: navigation[index].id
                                });

                                if (e.originalEvent !== undefined) { // if a monkey clicked on it...
                                    $(document).trigger('diy-editor-generic-sectionAccessed', {
                                        'sectionCodeName': 'sa-window-navigation.' + navigation[index].id
                                    });
                                }

                                /* if the callback's result is true, proceed */
                                if (typeof res === 'function' && res(e)) {
                                    $('#cc-sa-navi-tabs ul li').removeClass(
                                            'ui-tabs-selected').removeClass(
                                            'ui-state-active').find('a')
                                            .removeClass('active');
                                    $(this).parent().addClass(
                                            'ui-tabs-selected').addClass(
                                            'ui-state-active');
                                    $(this).addClass('active');
                                    return false;
                                }
                            });
                });

        /*
         * due to the fact that the tabs are not jQuery based, we will hover
         * them manually
         */
        $navi.find('.ui-state-default').hover(function() {
            $(this).addClass('ui-state-hover');
        }, function() {
            $(this).removeClass('ui-state-hover');
        });

        self.headerData.navi = navigation;

        /*
         * get it's width and compute a new width based on it's current one and
         * extraSpace
         */
        var naviWidth = $navi.width(), newMinWidth = parseInt($navi.width(), 10) + extraSpace;

        /* perform operations for resizable hehavior */
        if (behavior.resizable &&
                naviWidth > 0 &&
                newMinWidth > (behavior.resizable.minWidth || resizableOptions.minWidth)) {
            behaviors.resizable.hide(behavior.resizable);
            behaviors.resizable.show({
                minWidth : newMinWidth
            });
        }

        /* perform operations for size hehavior */
        if (behavior.size && naviWidth > 0) {
            var persistentWidth = 0; /*
                                         * first, suppose there is no saved
                                         * width for this window
                                         */

            if (behavior.resizable) {
                try { /*
                         * try and get it. whether the cause of the failure, it
                         * will still remain 0
                         */
                    persistentWidth = $.parseJSON($
                            .cookie('diy-siteadmin-window-size-persistentId-' +
                                    behavior.size.persistentId)).width;
                } catch (ee) {
                }
            }
            /*
             * the new width will be either persistentWidth or size width
             * (whichever is larger
             */
            var currentWidth = Math.max(persistentWidth, behavior.size.width ||
                    resizableOptions.minWidth);
            if (newMinWidth > currentWidth) { /*
                                                 * if there is the need, resize
                                                 * the window
                                                 */
                behaviors.size.show({
                    width : newMinWidth,
                    height : $win.height()
                });
            } else {
                behaviors.size.show({
                    width : currentWidth,
                    height : $win.height()
                });
            }
        }

        return self;
    };

    /**
     * hides the navigation (with tabs)
     */
    this.hideNavi = function () {
        $navi.hide();
    };

    /**
     * shows the navigation (with tabs)
     */
    this.showNavi = function () {
        $navi.show();
    };

    /**
     * resize the window to a certain size
     *
     * @param {object}
     *            newSize the new size, object with width and height values
     * @param {boolean}
     *            animate whether to animate
     */
    this.resize = function(newSize, animate) {

        /* in case it is ran without any sizes, just use the window's ones */
        if (!newSize) {
            newSize = {
                width : $win.width(),
                height : $win.height()
            };
        }

        /* attempt resizing upon window resize only if resizable */
        if (behavior.resizable) {
            if (!newSize.width) { /* fill with window width if missing */
                newSize.width = self.windowSize.width;
            }
            if (!newSize.height) { /* fill with window height if missing */
                newSize.height = self.windowSize.height;
            }
            /*
             * if width exceeds maximum window width, use the maximum window
             * size
             */
            if (newSize.width + windowMargin + sidebarWidth > $(window).width()) {
                newSize.width = getMaxWindowSize().maxWidth;
            }
            /* if the new height is bigger than the window height */
            if (newSize.height + windowMargin > $(window).height()) {
                newSize.height = getMaxWindowSize().maxHeight;
            }

            var minHeight = behavior.resizable.minHeight || resizableOptions.minHeight,
                maxHeight = behavior.resizable.maxHeight || resizableOptions.maxHeight,
                minWidth = behavior.resizable.minWidth || resizableOptions.minWidth,
                maxWidth = behavior.resizable.maxWidth || resizableOptions.maxWidth;

            /*
             * if trying to resize the window less than the minimum resizable
             * height
             */
            if ((newSize.height < minHeight) ||
                    (maxHeight != null && newSize.height > maxHeight)) {
                newSize.height = minHeight;
            }

            /* if bigger size than minimum width comes, use minimum width */
            if ((minWidth > newSize.width) ||
                    (maxWidth != null && newSize.width > maxWidth)) {
                newSize.width = behavior.resizable.minWidth;
            }
        }

        if (animate) { /* perform the resize by animating or not */
            $win.add($siteAdminWinHeader).animate({
                width : newSize.width
            }, speed, resizeContent);
        } else {
            $win.css($.extend(true, {}, newSize, {
                height : newSize.height
            }));
            resizeContent();
        }

        /**
         * resize the content within the window
         */
        function resizeContent() {
            /* finding and setting the content height */
            var headerOuterHeight = 0;
            if ($siteAdminWinHeader.is(':visible')) {
                headerOuterHeight = $('header').outerHeight();
            }
            var contentWrapperHeight = newSize.height -
                    (headerOuterHeight || windowHeaderHeight);

            if (behavior.footer) {
                contentWrapperHeight -= ($footer.outerHeight() || windowFooterHeight);
            }

            $contentWrapper.css({
                width : newSize.width,
                height : contentWrapperHeight
            });

            /* resize window header */
            $siteAdminWinHeader.width(newSize.width);

            /* store the new window size */
            $.extend(self.windowSize, newSize);

            /* wait until css is ready */
            setTimeout(controller.resizeSAC, 10);

            /* trigger the resize completed event */
            $(document).trigger('diy-siteadmin-window-resize-completed');

            /*
             * check if window contains a persistent size Id behavior, and if
             * so, save the size
             */
            if (behavior.size && behavior.size.persistentId) {
                $.cookie('diy-siteadmin-window-size-persistentId-' +
                        behavior.size.persistentId, JSON.stringify({
                    width : $win.width(),
                    height : $win.height()
                }), {
                    expires : 100,
                    path : '/'
                });
            }

            /* make sure that the pointer position is set correctly */
            self.checkSelectedPointerPosition();
        }
    };

    /**
     * Updates the save button with the given content
     *
     * @param btn
     *            the button
     */
    this.updateSaveBtn = function(btn, callback) {
        if (typeof btn === 'object') {
            btn = $(btn).get(0);
        }
        $saveBtn.html(btn);
        var buttonObj = $saveBtn.find('button');
        buttonObj.button();

        // allow a custom callback //
        buttonObj.unbind('click.customCallback');
        if ($.isFunction(callback)) {
            buttonObj.bind('click.customCallback', callback);
        }

        self.footerData.saveBtn = btn;
        return self;
    };

    var extButtonCallback = function(which) {
        try {
            var item = self.footerData.buttons[which], win = self
                    .getContentElement().get(0).contentWindow;
            if (win && typeof win.jQuery === 'function' &&
                    typeof item.event !== 'undefined' && item.event) {
                win.jQuery(win.document).trigger(item.event, null);
            } else if (typeof item.callback === 'function') {
                item.callback();
            }
        } catch (exception) {
            // ...
        }
    };

    var extCloseCallback = function() {
        extButtonCallback('close');
        $(document).unbind('diy-siteadmin-window-closed', extCloseCallback);
    };

    this.updateButtons = function(buttons) {

        /* buttons should have correct format */
        if (!buttons || typeof buttons !== 'object') {
            return;
        }

        self.footerData.buttons = buttons;

        /* prevent double close callback calls */
        $(document).unbind('diy-siteadmin-window-closed', extCloseCallback);

        /* if we have close button */
        if (buttons.hasOwnProperty('close')) {
            // TODO: is there a proper way of setting the close button text ?
            $('footer button[data-action="closeWindow"] span.ui-button-text').html(
                    buttons.close.text);
            $(document).bind('diy-siteadmin-window-closed', extCloseCallback);
        }

        var html = '';

        if (buttons.hasOwnProperty('primary') && buttons.primary) {
            html += '<button class="siteadmin-savebtn" id="cc-sa-window-savebtn" data-external-event="primary">';
            html += buttons.primary.text + '</button>';

        }
        if (buttons.hasOwnProperty('secondary') && buttons.secondary) {
            html += '<button style="margin-right: 10px;" class="button button-cancel"  data-external-event="secondary">';
            html += buttons.secondary.text + '</button>';
        }
        if (buttons.hasOwnProperty('checkbox') && buttons.checkbox) {
            var checkedType = buttons.checkbox.checked ? ' checked="checked" ' : ' ';
            html += '<input type="checkbox" id="cc-sa-window-checkbox"' + checkedType + 'data-external-event="checkbox">';
        }

        $saveBtn.html(html);
        if (buttons.hasOwnProperty('checkbox') && buttons.checkbox) {
            $saveBtn.find('input[type=checkbox]').diy_checkbox({
                boxLabel: buttons.checkbox.text,
                change: $.proxy(buttons.checkbox.callback)

//                checked: buttons.checkbox.checked
            });
//            $saveBtn.find('input[type=checkbox][data-external-event]').unbind().bind(
//                'change',
//                function(e) {
//                    extButtonCallback($(e.currentTarget).attr(
//                        'data-external-event'));
//                });
        }

        $saveBtn.find('button').button();
        $saveBtn.find('button[data-external-event]').unbind().bind(
                'click',
                function(e) {
                    extButtonCallback($(e.currentTarget).attr(
                            'data-external-event'));
                });
    };

    this.getContentWrapper = function() {
        return $contentWrapper;
    };

    this.checkSelectedPointerPosition = function() {
        /*
         * check that the cc-sa-sidebar-selected-pointer element is properly
         * positioned. On low resolutions the min height of the window will be
         * significantly lower than the bottom elements in the sidebar
         */
        var $sidebar = $('#cc-sa-sidebar'); // TODO surely there is a better way
                                            // to do this */
        var pointer = $sidebar
                .find('a.cc-sa-active span.cc-sa-sidebar-selected-pointer');
        if (pointer.length === 1) {
            /*
             * only specifically add display:block to the element if it was
             * previously hidden (had the style attribute modified by
             * jQuery.hide())
             */
            // TODO can we do this in some other way?
            if (pointer.attr('style')) {
                pointer.show();
            }

        }
    };

    /**
     * Close window click action
     *
     * @param obj
     * @param data
     */
    this.closeWindowClick = function(obj, data) {
        controller.close();
//        self.close(obj, data);
    };

    this.close = function(obj, data) {
//        controller.unload(obj, data);
        /*
         * do not close, animate the fading out except for ie8 which is doing
         * the animation choppy
         */
        if (data && data.fade && !$.isBrowser.ie8) {
            $win.animate({
                opacity : 0.05
            }, 600, function() {
                $(this).css('visibility', 'hidden').css('opacity', null);
            });
        }

        self.hide();

        if (behavior.overlay) {
            behaviors.overlay.hide();
        }

        /* deactivate the current SiteAdmin item */
        $(document).trigger('diy-siteadmin-window-closed');

        /* trigger close event inside the iframe, if event bind to it */
        if (self.footerData && self.footerData.buttons &&
                self.footerData.buttons.close &&
                self.footerData.buttons.close.event) {
            var target;
            if (self.contentType === 'iframe-local') {
                target = $iframe.contents();
            } else {
                target = $(document);
            }

            target.trigger(self.footerData.buttons.close.event);
        }

        return false;
    };

    /**
     * Click action on the save button
     *
     * @param action
     * @param data
     * @param switchMode
     */
    this.saveBtnClicked = function(action, data, switchMode) {
        /*
         * we check for mode here, because there are two buttons in FE, preview
         * and save directly
         */
        if (true == switchMode) {
            switchMode = 'save';
        } else {
            switchMode = 'preview';
        }

        switch (data) {
            case 'siteadmin-bg-form':
            case 'siteadmin-colors-form':
            case 'siteadmin-owncolor-form':
            case 'style_bg_userupload':
            case 'fontformattingform':
            case 'settingsstyleaction':
                if ('save' === switchMode) {
                    $(document.body).trigger('StylingSaved.BSA');
                } else {
                    $(document.body).trigger('StylingTried.BSA');
                }
                break;
        }

        /* the content iframe */
        var ifr = $iframe;

        /*
         * now we set a hidden input-field to check in BE for action(save or
         * preview)
         */
        var formDat = ifr.contents().find('#' + data).closest('form');
        var existingSwitchInput = formDat.find('input[name="switch_mode"]');
        if (existingSwitchInput.length) {
            existingSwitchInput.val(switchMode);
        }
        else {
            formDat.prepend($("<input>")
                .attr('name', 'switch_mode')
                .attr('type', 'hidden').attr('class', 'hidden')
                .val(switchMode)
            );
        }

        var iframeWindow = ifr.get(0).contentWindow;

        /* check the action and take appropiate action */
        switch (action) {
        case 'submit':
            try {
                var targetForm = iframeWindow.jQuery('#' + data);
                if (targetForm.length) {
                    /**
                     * XXX: see #DHDIY-12266
                     * xWebForms disables all form inputs on submit and re-enables them
                     * after the request is over. This can be used as a crude form of
                     * flagging so that we can avoid submitting twice if the user
                     * presses Save while another request is already in progress.
                     * We don't know what inputs will be there but we can reasonably
                     * assume there will be at least one, so grab the first.
                     */
                    var maySubmit = true;
                    var firstFormInput = targetForm.children(':input').first();
                    if (firstFormInput.length && firstFormInput.is(':disabled')) {
                        maySubmit = false;
                    }
                    if (maySubmit) {
                        // SiteCatalyst tracking
                        $(document).trigger('diy-editor-siteAdminWindow-submit', {
                            'formName': data,
                            'switchMode': switchMode,
                            'ifr': ifr
                        });
                        // submit the form
                        targetForm.submit();
                    }
                }
            } catch (e) {
            }
            break;

        case 'protection':
        case 'ui-interaction':
            try {
                iframeWindow.document.getElementById(data).click();
            } catch (e) {
            }
            break;

        default:
            break;
        }
    };

    /**
     * gets the maximum allowed window size
     */
    function getMaxWindowSize() {
        return {
            maxWidth : $(window).width() - windowMargin - sidebarWidth,
            maxHeight : $(window).height() - windowMargin
        };
    }

    /**
     * clears the content from the content div and from the iframe
     */
    this.clearContent = function() {
        /* hide the window content div */
//        $('#cc-sa-window-content').empty();
//        $win.remove();

        try {
            /* remove iframe contents before filling up */
//            $($iframe.contents().get(0).documentElement).remove();
        } catch (e) {
        }
    };

    this.loadingBox = (function() {
        var selectorId = 'loadingBox';
        var createBox = '<div id="' + selectorId + '" class="' + selectorId +
                '-loading"></div>';
        var errorWindow = '<div id="window-errorMessage">';
        errorWindow += '<div class="window-errorMessage-title">%title%</div><br/>';
        errorWindow += '<div class="window-errorMessage-description">%desc%</div>';
        errorWindow += '</div>';
        return {
            isUsed : false,
            options : {},
            timeout : null,
            init : function(opts) {
                this.options = opts;
                var keys = new Array('timeout', 'errorMessageTitle', 'errorMessageDescription');
                for ( var i = 0; i < keys.length; i++) {
                    if (typeof this.options[keys[i]] === 'undefined') {
                        this.options[keys[i]] = jimdoData.messages.siteAdminLoadingBox[keys[i]];
                    }
                }
                this.isUsed = true;
            },
            destroy : function(opts) {
                var $me = this.get();
                if ($me) {
                    $me.remove();
                }
                this.isUsed = false;
            },
            get : function(createIfNotExists) {
                var $me = $contentWrapper.find('#' + selectorId);
                if (!$me.length) {
                    if (createIfNotExists == true) {
                        $contentWrapper.prepend(createBox);
                        $me = $contentWrapper.find('#' + selectorId);
                    } else {
                        $me = false;
                    }
                }
                return $me;
            },
            clearTimeout : function() {
                if (this.timeout !== null) {
                    clearTimeout(this.timeout);
                }
            },
            resize : function() {
                if (!this.isUsed) {
                    return;
                }
                this.hide(true);
                this.show(true);
            },
            show : function(ignoreTimeout) {
                if (!this.isUsed) {
                    return;
                }
                var $me = this.get(true);
                $me.css({
                    width : $contentWrapper.width(),
                    height : $contentWrapper.height()
                }).show();
                // use visibility property instead of display so css gets rendered and size is calculated by the browser
                self.getContentElement().css('visibility', 'hidden');
                if (ignoreTimeout !== true) {
                    this.clearTimeout();
                    var me = this;
                    this.timeout = setTimeout(function() {
                        me.error.call(me);
                    }, this.options.timeout);
                }
            },
            hide : function(ignoreTimeout) {
                if (!this.isUsed) {
                    return;
                }
                var $me = this.get();
                if ($me) {
                    $me.hide();
                    // use visibility property instead of display so css gets rendered and size is calculated by the browser
                    self.getContentElement().css('visibility', 'visible');
                }
                if (ignoreTimeout !== true) {
                    this.clearTimeout();
                }
            },
            error : function() {
                this.clearTimeout();

                var $me = this.get();
                if ($me) {
                    errorWindow = errorWindow.replace('%title%',
                            this.options.errorMessageTitle);
                    errorWindow = errorWindow.replace('%desc%',
                            this.options.errorMessageDescription);
                    $me.prepend(errorWindow);
                    $me.removeClass('loadingBox-loading').addClass(
                            'loadingBox-error');
                }
                self.getContentElement().css('visibility', 'visible');
            }
        };
    }());

    return this;
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/window.js
 ** module id = 24
 ** module chunks = 0
 **/